import { Button } from "@/design-system/Button/Button";
import { cn } from "@/lib/utils";
import { useTranslation } from "@repo/shared/i18n";
import { ChevronDown, Layers } from "lucide-react";

/**
 * Opens the alternatives. On desktop it is the popover's own trigger, which
 * hands it the open state so the caret can flip; on mobile it drives the sheet.
 *
 * Same Button, size and variant as AddPlayerButton: the two sit together on
 * mobile and read as one pair of controls. `compact` drops the label for the
 * phone action row, where only the icon fits.
 */
export const AlternativesPill = ({
  open = false,
  onClick,
  stretch = false,
  compact = false,
  disabled = false,
}: {
  open?: boolean;
  onClick?: () => void;
  stretch?: boolean;
  /** Icon only. */
  compact?: boolean;
  /** Nothing to list yet: a solve is in flight, or it found nothing. */
  disabled?: boolean;
}) => {
  const { t } = useTranslation("sbcs");
  if (compact) {
    return (
      <Button
        variant="tertiary"
        size="small"
        icon={<Layers />}
        aria-label={t("streamline.alternatives")}
        onClick={onClick}
        disabled={disabled}
      />
    );
  }
  return (
    <Button
      variant="tertiary"
      size="small"
      iconPosition="right"
      /* No colour of its own, so the caret matches the plus next to it. */
      icon={
        <ChevronDown
          className={cn(
            "transition-transform duration-[250ms] ease-out",
            open && "rotate-180",
          )}
        />
      }
      onClick={onClick}
      stretch={stretch}
      disabled={disabled}
    >
      {t("streamline.alternatives")}
    </Button>
  );
};
